import { apiFetch, noop, reportTo, run } from "../api";
import { getGroupStatus, selectSessionId } from "./app-slice";

export const recurringPath = (groupId, id = null) =>
  `/groups/${groupId}/recurring${id == null ? "" : `/${id}`}`;

export const loadRecurring =
  (groupId, onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), recurringPath(groupId)),
      (list) => {
        if (list?.recurring?.length > 0) dispatch(getGroupStatus(groupId, true));
        onSuccess(list);
      },
      reportTo(onError, "Die wiederkehrenden Ausgaben konnten nicht geladen werden."),
    );

const changeRecurring =
  (groupId, id, options, fallback, onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), recurringPath(groupId, id), options),
      (list) => {
        dispatch(getGroupStatus(groupId, true));
        onSuccess(list);
      },
      reportTo(onError, fallback),
    );

export const saveRecurring = (groupId, id, recurring, onSuccess, onError) =>
  changeRecurring(
    groupId,
    id,
    { method: id == null ? "POST" : "PUT", body: { recurring } },
    "Die wiederkehrende Ausgabe konnte nicht gespeichert werden.",
    onSuccess,
    onError,
  );

export const setRecurringPaused = (groupId, id, paused, onSuccess, onError) =>
  changeRecurring(
    groupId,
    id,
    { method: "PUT", body: { paused } },
    paused
      ? "Die wiederkehrende Ausgabe konnte nicht pausiert werden."
      : "Die wiederkehrende Ausgabe konnte nicht fortgesetzt werden.",
    onSuccess,
    onError,
  );

export const deleteRecurring = (groupId, id, onSuccess, onError) =>
  changeRecurring(
    groupId,
    id,
    { method: "DELETE" },
    "Die wiederkehrende Ausgabe konnte nicht gelöscht werden.",
    onSuccess,
    onError,
  );
